import { z } from 'zod';

import { Form } from '../../DataCollection/Form';

export const DataCollection = z.object({
  form: Form,
});

export type DataCollection = z.infer<typeof DataCollection>;
